export const HELP_CENTER_MODULE_SCOPE = 'help_center';